export enum EAddressProvider {
  FRENCH_GOVERNMENT = "FRENCH_GOVERNMENT",
  GOOGLE = "GOOGLE",
}
